import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class JobPerformance extends ApplicationRecord {
  static jsonapiType = "job_performances";

  @Attr() candidateSubmissionNumber: {
    sectors: Array<string>;
    values: Array<number>;
  };

  @Attr() interviewAndRejectionRate: {
    months: Array<string>;
    interviewRates: Array<number>;
    rejectionRates: Array<number>;
  };

  @Attr() placementRate: {
    months: Array<string>;
    values: Array<number>;
  };

  @Attr() placementsMade: {
    months: Array<string>;
    values: Array<number>;
  };

  @Attr() costOnPlacements: {
    months: Array<string>;
    values: Array<number>;
  };

  @Attr() avgDaysToFirstSubmission: {
    months: Array<string>;
    values: Array<number>;
  };

  @Attr() avgJobSuccessFee: {
    months: Array<string>;
    values: Array<number>;
  };

  @Attr() fillRate: {
    months: Array<string>;
    values: Array<number>;
  };

  @Attr() avgTimeToHireDays: {
    stages: Array<string>;
    values: Array<number>;
  };

  @Attr() stageProgression: {
    stages: Array<string>;
    values: Array<number>;
  };

  @Attr() recruitmentProcess: {
    x: Array<string>;
    y: Array<string>;
  };

  @Attr() sectors: Array<String>
  @Attr() jobs: Array<String>
  @Attr() employerUsers: Array<String>
}

export default JobPerformance;
